import Vue from 'vue'
import to from 'await-to-js'
import client from '@/api/client'
import HOMEPAGE_QUERY from '@/api/gql/homepage/query/homepage.gql'

const DEFAULT_TEMPLATE = 'C'

const getCategorySliderData = vm => {
  // TODO: #3581 ⁃ Provide category slider data via GraphQl
  // TODO: #3407 ⁃ Add final hard-coded data for category slider
  const getFullUrl = vm.$store.getters['page/getFullUrl']
  const ctaText = vm.$t('discover_cta')
  const CATEGORY_SLIDER_DATA = [
    {
      title: vm.$t('road_running'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/7ahnQC9wA4eaLbkEclAN1I/6aab2c010c8d3410c510f107869b3eb9/Category_Slider-FW22-Running.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/shoes/road') }],
    },

    {
      title: vm.$t('bestsellers'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/1NiGE0JcFCWOGDrbv913F3/86ddb4121e66fcd2f081702a6cac3320/Category_Slider-FW22-BestSellers.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/?sort=bestseller') }],
    },

    {
      title: vm.$t('shoe_finder'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/39qCgwkWRZjwyr6c0UjSAT/d9d69a7b637e63eff3c953fe07704286/Category_Slider-FW22-Shoe_Finder.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/shoe-finder') }],
    },

    {
      title: vm.$t('latest'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/4BF5GUAm0TVYWFXApVaqvJ/7af7e9710801c54584b7593d011352f7/Category_Slider-FW22-New_Arrivals.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/?release_date=new-arrivals') }],
    },

    {
      title: vm.$t('apparel'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/6YoEeyEZH5y0MzZW0kdU0E/c9f8b30f6d2484d8d289dcf3a487e008/Category_Slider-FW22-Apparel.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/apparel') }],
    },

    {
      title: vm.$t('cloud_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/1MGU1tuzeVhqmAwuPf0BpT/fe5378ac7a0e62b5fa447db9e8d58571/Category_Slider-FW22-Cloud_Collection.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/cloud') }],
    },

    {
      title: vm.$t('accessories'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/3YJBtrH8rn69bTUq5akTcI/cf21b2ff19278c02c812a439f8bfa6b3/Category_Slider-FW22-Accessories.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/accessories') }],
    },

    {
      title: vm.$t('home_workout'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/3BDzBCKxiU67fOLAclmwww/8217291c8e6a6d7157d116a3fa905084/Category_Slider-FW22-Home_Workouts.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/homeworkout') }],
    },

    {
      title: vm.$t('the_roger_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/3HJ6SBo6KrFlMDHRvBi2hH/4ec4f87584129e3015e48d7fa18317a3/Category_Slider-FW22-TheRogerCollection.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/roger') }],
    },

    {
      title: vm.$t('outdoor_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/5HA76jyB1gwScOu8UZjiWb/52b4dd10c8c4e4f9b581a46d91b7236e/Category_Slider-FW22-Outdoor_Collection.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/outdoor') }],
    },
  ]

  return CATEGORY_SLIDER_DATA
}

const HomepageService = {
  async fetch(vm) {
    const [error, result] = await to(client.query({ query: HOMEPAGE_QUERY }))
    if (error) Vue.rollbar.error(error.message, error)
    const homepage = result?.data?.homepage || {}
    if (!homepage.template) homepage.template = DEFAULT_TEMPLATE
    return {
      ...homepage,
      categorySlider: getCategorySliderData(vm, homepage.template),
    }
  },
}

export default HomepageService
